<template>
    <div v-if="offer">
        <div class="offer-header">
            <div class="page-title">
                <h4> Vizualizare oferta {{offer.id}} din data:  {{ offer.created_at | moment("DD.MM.YYYY")}} </h4>
            </div>
        </div>
        <div class="user-logo-container" v-if="this.user">
            <div class="user-logo">
                <img :src="logo">
            </div>
        </div>
        <div class="row justify-content-center" v-if="offer.user">
          <div class="col-xl-4 col-lg-4 col-12">
            <ul class="template-offer-details">
              <h4> {{$t('txt.dateOfertant')}} </h4>
              <li> <span> {{$t('placeholder.numeCompanie')}}: </span> <p>
                {{ (this.offerData && this.offerData.company_name) ? this.offerData.company_name : ((this.offer.user.company_name) ? this.offer.user.company_name : '-') }} </p> </li>
                <li> <span> {{$t('placeholder.nume')}}: </span> <p>
                  {{ (this.offerData && this.offerData.first_name) ? this.offerData.first_name  : ((offer.user.first_name ) ? offer.user.first_name  : '-' )}}
                </p> </li>
                <li> <span> {{$t('placeholder.prenume')}}: </span> <p>
                  {{ (this.offerData && this.offerData.last_name) ? this.offerData.last_name  : ((offer.user.last_name ) ? offer.user.last_name  : '-') }}
                </p> </li>
                <li> <span> {{$t('placeholder.email')}}: </span> <p>
                  {{ (this.offerData && this.offerData.email) ? this.offerData.email  : ((offer.user.email ) ? offer.user.email  : '-') }}
                </p> </li>
                <li> <span> {{$t('placeholder.cui')}}: </span> <p>
                  {{ (this.offerData && this.offerData.cui) ? this.offerData.cui  : ((offer.user.cui ) ? offer.user.cui  : '-') }}
                </p> </li>
                <li> <span> {{$t('placeholder.banca')}}: </span> <p>
                  {{ (this.offerData && this.offerData.bank) ? this.offerData.bank  : ((offer.user.bank ) ? offer.user.bank  : '-') }}
                </p> </li>
                <li> <span> {{$t('placeholder.nrRegCom')}}: </span> <p>
                  {{ (this.offerData && this.offerData.nr_reg) ? this.offerData.nr_reg  : ((offer.user.nr_reg ) ? offer.user.nr_reg  : '-') }}
                </p> </li>
              </ul>
          </div>
          <div class="col-xl-4 col-lg-4 col-md-12" v-if="offer.client">
            <ul class="template-offer-details" v-if="parseInt(offer.client.type) === 2">
              <h4> {{$t('txt.dateClient')}} </h4>
              <li> <span> {{$t('placeholder.numeCompanie')}}: </span> <p>{{offer.client.company_name ? offer.client.company_name : '-'}} </p> </li>
              <li> <span> {{$t('placeholder.cui')}}: </span> <p>{{offer.client.cui ? offer.client.cui : '-'}} </p> </li>
              <li> <span> {{$t('placeholder.nrRegCom')}}: </span> <p>{{offer.client.nr_reg ? offer.client.nr_reg : '-'}} </p> </li>
              <li> <span> {{$t('placeholder.email')}}: </span> <p>{{offer.client.email ? offer.client.email : '-' }} </p> </li>
              <li> <span> {{$t('placeholder.telefon')}}: </span> <p>{{offer.client.phone ? offer.client.phone : '-'}} </p> </li>
            </ul>
            <ul class="template-offer-details" v-if="parseInt(offer.client.type) === 1">
              <h4> {{$t('txt.dateClient')}} </h4>
              <li> <span> {{$t('placeholder.nume')}}: </span> <p>{{offer.client.first_name}} </p> </li>
              <li> <span> {{$t('placeholder.prenume')}}: </span> <p>{{offer.client.last_name}}  </p> </li>
              <li> <span> {{$t('placeholder.email')}}: </span> <p>{{offer.client.email}} </p> </li>
              <li> <span> {{$t('placeholder.telefon')}}: </span> <p>{{offer.client.phone}} </p> </li>
              <li> <span> {{$t('placeholder.CNP')}}: </span> <p>{{offer.client.cnp}} </p> </li>
              <li> <span> {{$t('placeholder.CI')}}: </span> <p>{{offer.client.ci_number}} </p> </li>
              <li> <span> {{$t('placeholder.Serie')}}: </span> <p>{{offer.client.ci_series}} </p> </li>
            </ul>
          </div>
        </div>
        <div class="preview-offer-desc" v-if="offer.template_content">
            <h4> {{$t('txt.descriereOferta')}} </h4>
            <div class="offer-template-content" v-html="offer.template_content">
            </div>
        </div>
        <div class="preview-offer-client view-offer-headers">
            <h4> {{$t('txt.compozitieOferta')}} </h4>
        </div>
        <div class="composition-template offer-composition-template">
          <div class="offer-table-wrapper">
            <table>
              <thead>
                <tr>
                  <th>
                      <span>
                          {{$t('tableHeader.nrCrt')}}
                      </span>
                  </th>
                  <th>
                    <p class="final-table-header">
                      {{$t('placeholder.denumire')}}
                    </p>
                  </th>
                  <th>
                    <p class="final-table-header">
                      {{$t('placeholder.cantitate')}}
                    </p>
                  </th>
                  <th>
                    <p class="final-table-header">
                      {{$t('placeholder.pret')}}
                    </p>
                  </th>
                  <th>
                    <p class="final-table-header">
                      {{$t('txt.subtotal')}}
                    </p>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(offer_row, index) in offer.products" :key="`A-${offer_row.id}`">
                  <td width="3%">
                      <p> {{index + 1}} </p>
                  </td>
                  <td :tableheadData="$t('placeholder.denumire')">
                    <div class="final-offer-name">
                      <p> {{offer_row.name}} </p>
                    </div>
                  </td>
                  <td :tableheadData="$t('placeholder.cantitate')">
                    <div class="view-template-qty">
                      <p> {{offer_row.qty}} </p>
                    </div>
                  </td>
                  <td :tableheadData="$t('placeholder.pret')">
                    <div class="final-offer-price">
                      <p> {{offer_row.price | formatPrice}} </p>
                      <!--<p> RON </p>-->
                    </div>
                  </td>
                  <td :tableheadData="$t('txt.subtotal')">
                    <div class="final-offer-price">
                      <p> {{offer_row.subtotal | formatPrice}} </p>
                      <!--<p> RON </p>-->
                    </div>
                  </td>
                </tr>
                <tr v-for="offer_row in offer.services" :key="`B-${offer_row.id}`">
                  <td :tableheadData="$t('placeholder.denumire')">
                    <div class="final-offer-name">
                      <p> {{offer_row.name}} </p>
                    </div>
                  </td>
                  <td :tableheadData="$t('placeholder.cantitate')">
                    <div class="view-template-qty">
                      <p> {{offer_row.qty}} </p>
                    </div>
                  </td>
                  <td :tableheadData="$t('placeholder.pret')">
                    <div class="final-offer-price">
                      <p> {{offer_row.price | formatPrice}} </p>
                      <!--<p> RON </p>-->
                    </div>
                  </td>
                  <td :tableheadData="$t('txt.subtotal')">
                    <div class="final-offer-price">
                      <p> {{offer_row.subtotal | formatPrice}} </p>
                      <!--<p> RON </p>-->
                    </div>
                  </td>
                </tr>
                <tr v-for="offer_row in offer.post_services" :key="`C-${offer_row.id}`">
                  <!--                        <td tableheadData="Imagine" class="table-image-wrapper">
                  <div class="final-offer-image">
                  &lt;!&ndash;<img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSvQYCj1UoEtEMx4OB_fMUie4b0CAgBVa13w_CgbB6BIjceXrJCFQ">&ndash;&gt;
                </div>
              </td>-->
              <td :tableheadData="$t('placeholder.denumire')">
                <div class="final-offer-name">
                  <p> {{offer_row.name}} </p>
                </div>
              </td>
              <td :tableheadData="$t('placeholder.cantitate')">
                <div class="view-template-qty">
                  <p> {{offer_row.qty}} </p>
                </div>
              </td>
              <td :tableheadData="$t('placeholder.pret')">
                <div class="final-offer-price">
                  <p> {{offer_row.price | formatPrice}} </p>
                  <!--<p> RON </p>-->
                </div>
              </td>
              <td :tableheadData="$t('txt.subtotal')">
                <div class="final-offer-price">
                  <p> {{offer_row.subtotal | formatPrice}} </p>
                  <!--<p> RON </p>-->
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
        </div>
        <div class="composition-info">
            <ul>
                <li>
                    <h5> {{$t('txt.subtotal')}}:  </h5>
                    <p> {{offer.subtotal | formatPrice}} </p>
                </li>
                <!-- <li>
                    <h5> {{$t('tableHeader.discount')}}  </h5>
                    <span class="discount-label"> <i class="fas fa-percentage"></i> </span>
                    <span class="discount-view"> {{offer.discount}} </span>
                </li> -->
                <li>
                    <h5> {{$t('txt.total')}}  </h5>
                    <p> {{offer.total | formatPrice}}</p>
                </li>
                <li class="button-wrapper">
                  <button class="template-button" type="button" @click="sendOffer()">
                      <i class="far fa-paper-plane"></i>
                      {{$t('placeholder.trimiteOferta')}}
                  </button>
                </li>
            </ul>
        </div>
        <div class="certified-label">
            <div class="certified-logo">
                <p v-if="$hasRole(['partner'])"> {{$t('placeholder.partenerCompanie')}} </p>
                <img src="/logo.png">
            </div>
        </div>
        <div class="row" v-if="offer.notes">
          <div class="col-xl-6 col-lg-6 col-md-12">
            <div class="template-notes-wrapper">
                <h5> Lista notite </h5>
                <ul class="saved-notes">
                  <li :key="note.id" v-for="note in offer.notes">
                    <span>{{ formatDatesWithTime(note.timestamp) }} : </span>
                    <span class="note-box"> {{note.msg}} </span>
                  </li>
                </ul>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import OffersService from '../../api-services/offers.service'
import UsersService from '../../api-services/users.service'
export default {
  name: 'viewOffer',
  data () {
    return {
      logo: null,
      user: this.$store.getters.user,
      offer: null,
      offerData: null,
      offerDetails: null
    }
  },
  methods: {
    getUserOfferData () {
      UsersService.getOfferData(this.user.id)
        .then((response) => {
          this.offerData = response.data.data
        })
        .catch((error) => {
          console.log(error)
        })
    },
    checkLogo () {
      if (this.user.logo && this.user.logo.length) {
        this.logo = this.user.logo[0].link
      } else {
        this.logo = null
      }
    },
    getOffer () {
      OffersService.get(this.$route.params.id)
        .then((response) => {
          this.offer = response.data.data
          this.$store.dispatch('hideLoading')
        })
        .catch((error) => {
          console.log(error)
          this.$store.dispatch('hideLoading')
        })
    },
    sendOffer () {
      this.$store.dispatch('showLoading')
      // this.adjustLoadingContainer()
      OffersService
        .sendOffer({ id: this.$route.params.id })
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.$notify({
            group: 'succes',
            type: 'success',
            // title: 'Added',
            text: this.$t('success.ofertaTrimisa'),
            'animation-type': 'css'
          })
          // this.$router.push('/offers')
        }).catch((error) => {
          this.$store.dispatch('hideLoading')
          this.$notify({
            group: 'error',
            type: 'error',
            title: this.$t('errors.errorTitle'),
            text: error.response.data.error,
            'animation-type': 'css'
          })
        })
    }
  },
  created () {
    this.getOffer()
    this.checkLogo()
    this.getUserOfferData()
  }
}
</script>
